import React, { useEffect } from 'react'
import resume from "../Data/Abhinav_Resume.pdf"
import ResumeImage from "../Data/Resume.png"

export const Resume = () => {
    const openPDF = () => {
        window.open(resume, '_blank');
    };

    useEffect(() => {
        document.title = 'Abhinav - Resume';
    }, []);

    return (
        <div className='container'>
            <div className="section-mid fx-col fx-far fx-center fx-gap-s">
                <div className="img-frame-resume cursor-pointer" onClick={openPDF}>
                    <img src={ResumeImage} alt="" className='img' />
                </div>
                <div className="w-80">
                    <p className='txt-center-align ft-italic'>
                        Click the image for a full resolution PDF of my Resume.
                    </p>
                </div>
            </div>
        </div>
    )
}
